// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__365iu","errorLogs":"styles_errorLogs__3HS7Y"};